import { render, staticRenderFns } from "../templates/normal_fcont_207.html?vue&type=template&id=588428aa&scoped=true&"
import script from "./normal_fcont_207.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_207.vue?vue&type=script&lang=js&"
import style0 from "./normal_fcont_207.vue?vue&type=style&index=0&id=588428aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588428aa",
  null
  
)

export default component.exports